var XWrap =
/*#__PURE__*/
function () {
  function XWrap(fn) {
    this.f = fn;
  }

  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };

  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };

  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return XWrap;
}();

export default function _xwrap(fn) {
  return new XWrap(fn);
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_xwrap.js
// module id = 897
// module chunks = 1